<template>
  <AppNavbar />
  <div class="d-flex flex-column reports-layout">
    <AppHeader title="Reportes" class="header-compact px-4 border-bottom" />
    <div class="d-flex flex-grow-1">
      <aside class="sidebar p-3">
        <ul class="nav flex-column gap-1">
          <li v-for="item in menu" :key="item.name" class="nav-item">
            <router-link class="nav-link" :to="item.to" exact-active-class="active">
              <i :class="item.icon + ' me-2'"></i>{{ item.label }}
            </router-link>
          </li>
        </ul>
      </aside>
      <main class="flex-fill p-4">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppNavbar from '@/components/AppNavbar.vue'

export default {
  name: 'ReportesLayout',
  components: { AppHeader, AppNavbar },
  data() {
    return {
      menu: [
        { name: 'reportes-home', label: 'Resumen', to: { name: 'ReportesHome' }, icon: 'bi bi-grid-1x2' },
        // Faltaba: la home ofrecía seis reportes y el sidebar listaba cinco.
        // «Ingresos» es el más nuevo y el único que ve los cobros de
        // suscripción, así que va primero, igual que en la home.
        { name: 'reportes-ingresos', label: 'Ingresos', to: { name: 'ReportesIngresos' }, icon: 'bi bi-cash-stack' },
        { name: 'reportes-ventas', label: 'Ventas', to: { name: 'ReportesVentas' }, icon: 'bi bi-cash-coin' },
        { name: 'reportes-cierres-caja', label: 'Cierres de caja', to: { name: 'ReportesCierresCaja' }, icon: 'bi bi-safe2' },
        { name: 'reportes-productos', label: 'Productos vendidos', to: { name: 'ReportesProductosVendidos' }, icon: 'bi bi-box-seam' },
        // El negocio que somos (D40). «Cuentas por cobrar» es la deuda de las
        // cuotas; el credito de almacen quedo abajo, con su nombre real.
        { name: 'reportes-cuentas-cobrar', label: 'Cuentas por cobrar', to: { name: 'ReportesCuentasPorCobrar' }, icon: 'bi bi-wallet2' },
        { name: 'reportes-cobranza-periodo', label: 'Cobranza del período', to: { name: 'ReportesCobranzaPeriodo' }, icon: 'bi bi-graph-up-arrow' },
        { name: 'reportes-deuda-responsable', label: 'Deuda por responsable', to: { name: 'ReportesDeudaPorResponsable' }, icon: 'bi bi-person-lines-fill' },
        { name: 'reportes-utilidad', label: 'Utilidad', to: { name: 'ReportesUtilidad' }, icon: 'bi bi-bar-chart-steps' },
        { name: 'reportes-compras', label: 'Compras por proveedor', to: { name: 'ReportesComprasProveedor' }, icon: 'bi bi-truck' },
        { name: 'reportes-creditos-clientes', label: 'Créditos de clientes', to: { name: 'ReportesCreditosClientes' }, icon: 'bi bi-credit-card' },
      ],
    }
  },
}
</script>

<style scoped>
.reports-layout {
  min-height: 100vh;
}

.header-compact {
  padding-top: .5rem;
  padding-bottom: .5rem;
}

.sidebar {
  width: 260px;
  background: #fff;
  border-right: 1px solid #e5e5e5;
}

.sidebar .nav-link {
  color: #111;
  border-radius: .25rem;
  padding: .6rem .9rem;
}

.sidebar .nav-link:hover {
  background: #f2f2f2;
  color: #111;
}

.sidebar .nav-link.active {
  background: #111;
  color: #fff;
  font-weight: 600;
}

main {
  background: #f9f9f9;
  overflow-y: auto;
}
</style>
